'use client'

// SessionStoreHydrator — restores the Zustand session store's persisted, user-
// specific values (affiliateCode + discountCode) from localStorage AFTER mount
// (Overmind retirement, Phase C2 part 1). The session store starts EMPTY (null) so
// the SSR HTML and the first client render carry no per-user code (cache-safety
// #188 + no #418/#423); this tiny island — mounted ONCE in the server SiteChrome
// shell, so it runs on every page — calls hydrateFromLocalStorage() in a mount
// effect to read the visitor's saved codes once the first render has committed.
//
// It renders nothing. hydrateFromLocalStorage() is idempotent (guarded by an
// internal flag), so co-existing with RegionPageClient's QueryParamEffects (which
// also calls it before applying the entry-time query codes) is safe.
import { useEffect } from 'react'
import { useSessionStore } from '../store/sessionStore'

export default function SessionStoreHydrator() {
  useEffect(() => {
    useSessionStore.getState().hydrateFromLocalStorage()
  }, [])
  return null
}
